import React, { type ComponentType } from 'react';

import { cssMap, cx } from '@atlaskit/css';
/* eslint-disable-next-line @atlassian/tangerine/import/entry-points -- legacy onboarding baseline */
import IconTile from '@atlaskit/icon/icon-tile';
import type { IconTileProps, NewCoreIconProps } from '@atlaskit/icon/types';
import { Box, Flex, Text } from '@atlaskit/primitives/compiled';
import Suspense from '@atlaskit/react-ufo/suspense';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	stickyTopBase: {
		width: '100%',
		flexShrink: 0,
		position: 'relative',
		borderRadius: 'inherit',
		backgroundColor: token('elevation.surface.sunken'),
		borderBottomWidth: token('border.width'),
		borderBottomStyle: 'solid',
		borderBottomColor: 'transparent',
		borderImageSlice: 1,
		borderImageSource: 'linear-gradient(90deg, #1f69da 0%, #c16cd4 35%, #f5a117 70%, #79ae44 100%)',
	},
	stickyTop: {
		paddingBlockStart: token('space.400'),
		paddingInlineEnd: token('space.200'),
		paddingBlockEnd: token('space.200'),
		paddingInlineStart: token('space.200'),
	},
	stickyTopFullScreen: {
		paddingBlockStart: token('space.200'),
		paddingInlineEnd: token('space.200'),
		paddingBlockEnd: token('space.200'),
		paddingInlineStart: token('space.200'),
	},
	row: {
		alignItems: 'flex-start',
		gap: token('space.100'),
		minWidth: '0px',
	},
	titleText: {
		minWidth: '0px',
		flex: 1,
	},
});

export type RovoConversationTitleBlockProps = {
	title: string;
	icon?: ComponentType<NewCoreIconProps>;
	iconAppearance?: IconTileProps['appearance'];
	isFullScreen?: boolean;
	testId?: string;
};

export function RovoConversationTitleBlock({
	title,
	icon,
	iconAppearance = 'blue',
	isFullScreen = false,
	testId = 'rovo-conversation-title-block',
}: RovoConversationTitleBlockProps): React.JSX.Element {
	return (
		<Box
			xcss={cx(styles.stickyTopBase, isFullScreen ? styles.stickyTopFullScreen : styles.stickyTop)}
			testId={testId}
		>
			<Flex xcss={styles.row}>
				{icon && (
					<Suspense interactionName="rovo-conversation-assistant-title-block" fallback={null}>
						<IconTile icon={icon} label={title} appearance={iconAppearance} size="small" />
					</Suspense>
				)}
				<Box xcss={styles.titleText}>
					<Text size="large" maxLines={2}>
						{title}
					</Text>
				</Box>
			</Flex>
		</Box>
	);
}
